import React from 'react';
import { TmntText, TmntHtml } from '../../Common';
import QRCodeReturn from './QRCodeReturn';
import { stepTwoProps } from './props';

const shippingConfig = [
  {
    key: 'returnByDate',
    check: (props) => props.returnByDate,
    render: (props) => <p><TmntText tmnt={props.returnByDate} /></p>,
  },
  {
    key: 'qrCode',
    check: (props) => props.rmaNumber,
    render: (props) => <QRCodeReturn rmaNumber={props.rmaNumber} />,
  },
  {
    key: 'searchQRCodeLocations',
    check: (props) => props.searchQRCodeLocations,
    render: (props) => <p><TmntHtml tmnt={props.searchQRCodeLocations} /></p>,
  },
  {
    key: 'returnAvoidCancellation',
    check: (props) => props.returnAvoidCancellation,
    render: (props) => <p><TmntHtml tmnt={props.returnAvoidCancellation} /></p>,
  },
  {
    key: 'carrierLocator',
    check: (props) => props.carrierLocator,
    render: (props) => <p><TmntHtml tmnt={props.carrierLocator} /></p>,
  },
  {
    key: 'returnLabelGenerated',
    check: (props) => props.returnLabelGenerated,
    render: (props) => <p><TmntText tmnt={props.returnLabelGenerated} /></p>,
  },
  {
    key: 'returnLabelWaiting',
    check: (props) => props.returnLabelWaiting,
    render: (props) => <p><TmntText tmnt={props.returnLabelWaiting} /></p>,
  },
  {
    key: 'nextStepsQRCodeProvided',
    check: (props) => props.nextStepsQRCodeProvided,
    render: (props) => <p><TmntHtml tmnt={props.nextStepsQRCodeProvided} /></p>,
  },
  {
    key: 'dhlReturnNote',
    check: (props) => props.dhlReturnNote,
    render: (props) => <p><TmntText tmnt={props.dhlReturnNote} /></p>,
  },
  {
    key: 'dhlReturnNumber',
    check: (props) => props.dhlReturnNumber,
    render: (props) => <p><TmntText tmnt={props.dhlReturnNumber} /></p>,
  },
  {
    key: 'qrCodePurolatorServiceDetails',
    check: (props) => props.qrCodePurolatorServiceDetails,
    render: (props) => <p><TmntText tmnt={props.qrCodePurolatorServiceDetails} /></p>,
  },
  {
    key: 'eligibleDropOffLocations',
    check: (props) => props.eligibleDropOffLocations?.value,
    render: (props) => <p><TmntHtml tmnt={props.eligibleDropOffLocations.value} /></p>,
  },
  {
    key: 'returnLabelProvided',
    check: (props) => props.returnLabelProvided,
    render: (props) => <p><TmntHtml tmnt={props.returnLabelProvided} /></p>,
  },
  {
    key: 'returnMethodCustomerShippingShipTo',
    check: (props) => props.returnMethodCustomerShippingShipTo,
    render: (props) => <p><TmntText tmnt={props.returnMethodCustomerShippingShipTo} /></p>,
  },
  {
    key: 'returnAddress',
    check: (props) => props.returnAddress,
    render: (props) => <p><TmntText tmnt={props.returnAddress} /></p>,
  },
];

export default function StepTwoContent({ stepTwo }) {
  return (
    <div className="step2-shipping-method-content" data-testid="shipping-method-content">
      {shippingConfig.map(({ key, check, render }) => {
        if (!check(stepTwo)) return null;
        return <React.Fragment key={key}>{render(stepTwo)}</React.Fragment>;
      })}
    </div>
  );
}

StepTwoContent.propTypes = {
  stepTwo: stepTwoProps.isRequired,
};
